import { useState } from "react";
import { auth, db } from "../../../firebase/config";
import { createUserWithEmailAndPassword } from "firebase/auth";
import { doc, setDoc } from "firebase/firestore";
import { useNavigate, Link } from "react-router-dom";
import "./Register.css"; // Importando o CSS específico

export function Register() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [nome, setNome] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const navigate = useNavigate();

  const handleRegister = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");

    try {
      // 1. Cria no Auth
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        email,
        password,
      );
      const user = userCredential.user;

      // 2. Cria o Perfil no Firestore (Role fixa como 'client')
      await setDoc(doc(db, "users", user.uid), {
        nome: nome,
        email: email,
        role: "client",
        createdAt: new Date(),
        carrinho: [],
      });

      navigate("/"); // Redireciona para a Home
    } catch (err) {
      if (err.code === "auth/email-already-in-use") {
        setError("Este e-mail já está cadastrado.");
      } else if (err.code === "auth/weak-password") {
        setError("A senha deve ter pelo menos 6 caracteres.");
      } else {
        setError("Erro ao criar conta. Tente novamente.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="register-screen">
      <div className="register-container">
        <header className="register-header">
          <span>REPIQUE</span>
          <h1>Criar Conta</h1>
          <div className="divider"></div>
        </header>

        <form onSubmit={handleRegister} className="register-form">
          {error && <p className="error-message">{error}</p>}

          <div className="input-group">
            <label>NOME COMPLETO</label>
            <input
              type="text"
              placeholder="Como prefere ser chamado?"
              value={nome}
              onChange={(e) => setNome(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>E-MAIL</label>
            <input
              type="email"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="input-group">
            <label>SENHA</label>
            <input
              type="password"
              placeholder="Mínimo 6 caracteres"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="btn-register" disabled={loading}>
            {loading ? "PROCESSANDO..." : "FINALIZAR CADASTRO"}
          </button>
        </form>

        <footer className="register-footer">
          <p>
            Já possui uma conta?
            <Link to="/login">Fazer Login</Link>
          </p>
        </footer>
      </div>
    </div>
  );
}
